import type { EnumBannerType, EnumBannerVariant } from "./BannerTypes";

export const getBannerIconName = (type: EnumBannerType) => {
  switch (type) {
    case "success":
      return "circle-check-outline";
    case "error":
      return "triangle-exclamation-outline";
    case "warning":
      return "triangle-exclamation-outline";
    case "opportunity":
      return "gem-outline";
    case "info":
    default:
      return "circle-i-outline";
  }
};

export const getBannerIconColor = (
  type: EnumBannerType,
  variant: EnumBannerVariant
) => {
  const isGhostVariant = variant === "ghost";
  switch (type) {
    case "success":
      return isGhostVariant
        ? "container.border.decorative.green"
        : "icon.success";
    case "error":
      return isGhostVariant ? "container.border.decorative.red" : "icon.error";
    case "warning":
      return isGhostVariant
        ? "container.border.decorative.yellow"
        : "icon.warning";
    case "opportunity":
      return isGhostVariant
        ? "container.border.decorative.purple"
        : "icon.opportunity";
    case "info":
    default:
      return isGhostVariant ? "container.border.decorative.blue" : "icon.info";
  }
};
